const POSTER_BASE_URL = 'https://doramahype.ru/uploads/posters';

export function getPosterUrl(posterUrl) {
  if (!posterUrl) return null;
  return `${POSTER_BASE_URL}/${posterUrl}`;
}
